<ul class="nav nav-tabs" role="tablist" [ngClass]="getClass()">
  @for (item of items; track item) {
    <li class="nav-item text-center" matRipple>
      <a role="tab" [ngClass]="{active: $tab() === item.tab, disabled : item.disabled }"
        [title]="item.title" [ngbTooltip]="item.title" (click)="onClick(item)">

        @if (item.showIcon() && item.iconType === 'fa') {
          <span class="icon">
            <i class="fa-fw fa-lg" [ngClass]="item.icon"></i>
          </span>
        }

        @if (item.showIcon() && item.iconType === 'dx') {
          <span class="icon">
            <i class="dx-icon" [ngClass]="item.icon"></i>
          </span>
        }

        @if (item.showText()) {
          <span class="d-none d-lg-inline">{{item.title}}</span>
        }

      </a>
    </li>
  }
</ul>
